import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'card_registered':
        return 'CreditCard';
      case 'payment_processed':
        return 'DollarSign';
      case 'card_restricted':
        return 'Shield';
      case 'user_created':
        return 'UserPlus';
      case 'card_activated':
        return 'CheckCircle';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'card_registered':
        return 'text-accent';
      case 'payment_processed':
        return 'text-success';
      case 'card_restricted':
        return 'text-warning';
      case 'user_created':
        return 'text-accent';
      case 'card_activated':
        return 'text-success';
      default:
        return 'text-text-muted';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const time = new Date(timestamp);
    const diffInMinutes = Math.floor((now - time) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary">Recent Activity</h3>
        <Button
          variant="ghost"
          iconName="ExternalLink"
          iconPosition="right"
          onClick={() => window.location.href = '/reports-analytics'}
          className="text-sm"
        >
          View All
        </Button>
      </div>
      
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities.map((activity, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 hover:bg-hover rounded-lg transition-colors duration-150">
            <div className={`w-8 h-8 rounded-full bg-background flex items-center justify-center flex-shrink-0 ${getActivityColor(activity.type)}`}>
              <Icon name={getActivityIcon(activity.type)} size={16} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-text-primary">
                <span className="font-medium">{activity.user}</span> {activity.action}
                {activity.target && (
                  <span className="font-medium"> {activity.target}</span>
                )}
              </p>
              <div className="flex items-center space-x-2 mt-1">
                <span className="text-xs text-text-muted">
                  {formatTimeAgo(activity.timestamp)}
                </span>
                {activity.amount && (
                  <span className="text-xs font-mono text-success">
                    {activity.amount}
                  </span>
                )}
                {activity.cardId && (
                  <span className="text-xs font-mono text-text-muted">
                    {activity.cardId}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;